const memoryCache = {};
const FALLBACK_KEY = '__fallback_session_storage__';

function isStorageAvailable() {
    try {
        const storage = window.sessionStorage;
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return false;
    }
}

export function setAppData(key, value) {
    if (!key) return;

    const stringValue = String(value);

    memoryCache[key] = stringValue;

    if (isStorageAvailable()) {
        sessionStorage.setItem(key, stringValue);
    }

    try {
        if (window.history && history.replaceState) {
            const currentFallback = history.state?.[FALLBACK_KEY] || {};
            currentFallback[key] = stringValue;
            history.replaceState({ ...history.state, [FALLBACK_KEY]: currentFallback }, '');
        }
    } catch (e) {}

    try {
        let nameStorage = {};
        if (window.name) {
            try { nameStorage = JSON.parse(window.name); } catch (e) { nameStorage = {}; }
        }
        nameStorage[key] = stringValue;
        window.name = JSON.stringify(nameStorage);
    } catch (e) {}
}

export function getAppData(key) {
    if (!key) return null;

    if (memoryCache[key] !== undefined) {
        return memoryCache[key];
    }

    if (isStorageAvailable()) {
        const res = sessionStorage.getItem(key);
        if (res !== null) {
            memoryCache[key] = res;
            return res;
        }
    }

    if (window.history && history.state && history.state[FALLBACK_KEY]) {
        const fallbackStorage = history.state[FALLBACK_KEY];
        if (fallbackStorage[key] !== undefined) {
            memoryCache[key] = fallbackStorage[key];
            return memoryCache[key];
        }
    }

    if (window.name) {
        try {
            const nameStorage = JSON.parse(window.name);
            if (nameStorage && nameStorage[key] !== undefined) {
                memoryCache[key] = nameStorage[key];
                return memoryCache[key];
            }
        } catch (e) {}
    }

    return null;
}

export function removeAppData(key) {
    if (!key) return;

    delete memoryCache[key];

    if (isStorageAvailable()) {
        sessionStorage.removeItem(key);
    }

    try {
        if (history.state && history.state[FALLBACK_KEY]) {
            const currentFallback = { ...history.state[FALLBACK_KEY] };
            delete currentFallback[key];
            history.replaceState({ ...history.state, [FALLBACK_KEY]: currentFallback }, '');
        }
    } catch (e) {}

    try {
        if (window.name) {
            const nameStorage = JSON.parse(window.name);
            delete nameStorage[key];
            window.name = JSON.stringify(nameStorage);
        }
    } catch (e) {}
}